import type { FlowContextInterface } from 'contexts/FlowContext';
import { FlowActionTypes } from 'contexts/FlowContext';

export const selectionModelCB = (sender: any, evt: any, ctx: FlowContextInterface | null) => {
  if (sender.cells.length) {
    const cell = sender.cells[0];
    if (cell.isPort) {
      ctx?.dispatch({
        type: FlowActionTypes.SELECT_COMPONENT,
        payload: {
          componentId: cell.parent?.value?.compId,
          port: cell.value?.key,
          flowId: cell.parent?.value?.flowUuid
        }
      });
    } else if (cell.edge) {
      ctx?.dispatch({
        type: FlowActionTypes.SELECT_COMPONENT,
        payload: {
          componentId: cell.source?.parent.value?.compId,
          port: cell.source.value?.key,
          targetComponentId: cell.target?.parent.value?.compId,
          targetPort: cell.target.value?.key,
          flowId: cell.target?.parent.value?.flowUuid
        }
      });
    } else {
      const selectedCompId = cell.value?.compId;
      if (selectedCompId) {
        if (cell.virtualComponentType === 'tail') {
          ctx?.dispatch({
            type: FlowActionTypes.SELECT_COMPONENT,
            payload: {
              flowPort: selectedCompId,
              flowId: cell.value?.flowUuid,
              configPath: cell.value.virtualConfigPath
            }
          });
        } else if (cell.virtualComponentType === 'trigger') {
          ctx?.dispatch({
            type: FlowActionTypes.SELECT_COMPONENT,
            payload: { trigger: selectedCompId, flowId: cell.value?.flowUuid, configPath: cell.value.virtualConfigPath }
          });
        } else {
          ctx?.dispatch({
            type: FlowActionTypes.SELECT_COMPONENT,
            payload: { componentId: selectedCompId, flowId: cell.value?.flowUuid }
          });
        }
      }
    }
  } else {
    ctx?.dispatch({ type: FlowActionTypes.SELECT_COMPONENT, payload: null });
  }
};
